export default __webpack_public_path__ + "static/media/faceExample.c46d18b0.jpg";